import type { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from '@/shared/constants';
import type { Features } from '@/shared/ui';
import { useFeatureFlags } from '@/shared/ui';

interface Props {
  feature: Features;
  children?: ReactNode;
}

export function FeatureGuard({ feature, children }: Props) {
  const { isFeatureAvailable } = useFeatureFlags();

  if (!isFeatureAvailable(feature)) {
    return <Navigate to={ROUTES.home} />;
  }

  return children ? children : <Outlet />;
}
